import {Graphics, Matrix} from 'pixi.js';
import {BoundsRect} from '@gongxigames/framework/core/utils';

export type TextInputStyle = {
    multiline?: string;
    fontFamily?: string;
    fontSize?: string;
    fontWeight?: string;
    fontVariant?: string;
    fontStyle?: string;
    color?: string;
    letterSpacing?: string;
    textAlign?: string;
    textIndent?: string;
    padding?: string;
    maxLength?: number;
    width: string;
};

export type TextInputBackgroundStyle = {
    fill: number;
    rounded?: number;
    stroke?: {
        width?: number;
        color?: number;
        alpha?: number;
    };
};

export enum TextInputState {
    DEFAULT = 'default',
    DISABLED = 'disabled',
    FOCUSED = 'focused',
}

export type BoxCache = {
    [TextInputState.DEFAULT]: Graphics | null;
    [TextInputState.DISABLED]: Graphics | null;
    [TextInputState.FOCUSED]: Graphics | null;
};

export type PreviousState = {
    state?: TextInputState;
    input_bounds?: DOMRect;
    canvas_bounds?: BoundsRect;
    world_transform?: Matrix;
    world_alpha?: number;
    world_visible?: boolean;
};

export type PaddingTuple = [number, number, number, number];

export type TextInputBox = {
    [TextInputState.DEFAULT]: TextInputBackgroundStyle;
    [TextInputState.DISABLED]?: TextInputBackgroundStyle;
    [TextInputState.FOCUSED]?: TextInputBackgroundStyle;
};

export type TextInputBoxGenerator = (width: number, height: number, state: TextInputState) => Graphics;

export type TextInputOptions = {
    input: TextInputStyle;
    box?: TextInputBox | TextInputBoxGenerator;
    disabledPasteFromClipboard?: boolean;
    name?: string;
};

export type TextInputSelection = [number | null, number | null];
